<template>
  <ModalDialog
    ref="dialog"
    id="mydialog"
    @ok="onSave"
    @cancel="cancelFeedbackModal"
    :showCancelIcon="false"
    :displayCancelButton="false"
    :posX="posX"
    :posY="posY"
    :dlgStyle="dlgStyle"
    :displayOkButton="true"
    labelOk="Ok"
    :title="$t('participantModal.confirmTitle')"
    titleCss="text-weight-semi-bold justify-content-center"
  >
    <div ref="mydialog" class="dlg-choice">
      <div class="">
        <slot>
          <div class="text-font-size-16 text-center">
            <div
              class="text-label mb-1 text-left"
              v-html="confirmText"
            ></div>
          </div>
        </slot>
      </div>
    </div>
  </ModalDialog>
</template>
<script>
import { constants } from '@/shared/constant';
//import { faTachometerSlow } from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'ModalThanksDialog',

  data() {
    return {
      posX: 0,
      posY: 0,
      thanksDialog: null,
      confirmText: null,
    };
  },

  props: {
    labelOk: {
      type: String,
    },
    submittingParticipant: {
      type: Object,
    },
  },

  computed: {
    dlgStyle() {
      //const dlgWidth = 360;

      const dlgHeight = 360 + 100;
      const padding = 20;

      if (this.mobileView) {
        let top = this.posY;
        if (top + dlgHeight + padding > window.innerHeight)
          top = window.innerHeight - dlgHeight - padding;

        return 'margin:' + top + 'px auto';
      }

      // let left = this.posX;
      // if (left + dlgWidth + padding > window.innerWidth)
      //   left = window.innerWidth - dlgWidth - padding;

      // let top = this.posY;
      // if (top + dlgHeight + padding > window.innerHeight)
      //   top = window.innerHeight - dlgHeight - padding;

      // const s = ';left:' + left + 'px; top:' + top + 'px';
      const s = 'width: 470px; margin:50px auto;max-height: 80%;';
      return s;
    },
    mobileView() {
      return this.$store.state.mobileView;
    },

    getDescriptionLength() {
      return (
        (this.task.description ? this.task.description.length : 0) +
        ' / ' +
        constants.textAreaMaxCharacterLimit
      );
    },
   
  },

  methods: {
    openModal(event = null) {
      if (event) {
        this.posX = event.clientX;
        this.posY = event.clientY;
      }
      const email = this.submittingParticipant?.user?.email;
      if (email) {
        const msg = this.$t('participantModal.confirmText');
        this.confirmText = msg.replaceAll('%s', email);
      } else {
        this.confirmText = this.$t('participantModal.confirmTextWithoutEmail');
      }

      this.thanksDialog.openModal(event);
    },

    cancelFeedbackModal() {
      this.$refs.dialog.closeModal();
      console.info('Cancel Thanks');
    },

    closeModal() {
      this.thanksDialog.closeModal();
    },
    onSave() {
      this.thanksDialog.closeModal();
      console.info('Submit  Thanks');
    },
  },

  mounted() {
    this.thanksDialog = this.$refs.dialog;
    console.info('Thanks Dialog Mointed');
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/style.scss';

input.tasks-cont {
  width: 50px;
}
</style>
